import React, { useState } from "react";
import config from "../../../config/config";
import { Link } from "react-router-dom";
import navigationsLinks, {
  BOXIGO_WEBSITE_LINKS,
} from "../../../constants/navigation_links";
export default function Footer() {
  const JSX = (
    <>
      <footer className="footer container-fluid ">
        <div className="row">
          <div className="col-12">
            <div className="container footer-nav-container">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-3 col-xl-3 footer-branding">
                  <div className="company-logo">
                    <img
                      src={`${config.customerPortal}assets/images/home/boxigo_logo_small.png`}
                      alt="boxigo_logo_small"
                    />
                  </div>
                  <div className="social-media-link mt-4">
                    <ul className="list">
                      <li>
                        <a
                          href={BOXIGO_WEBSITE_LINKS.facebook_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${config.customerPortal}assets/images/home/facebook.png`}
                            alt="facebook-social-links"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={BOXIGO_WEBSITE_LINKS.twitter_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${config.customerPortal}assets/images/home/twitter.png`}
                            alt="twitter-social-links"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={BOXIGO_WEBSITE_LINKS.linkedin_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${config.customerPortal}assets/images/home/Subtraction 1.png`}
                            alt="linked-in-social-links"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={BOXIGO_WEBSITE_LINKS.instagram_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${config.customerPortal}assets/images/home/instagram.png`}
                            alt="instagram-social-links"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-9 col-xl-9">
                  <div className="footer-nav-links">
                    <ul className="p-0">
                      <li>
                        <a href={BOXIGO_WEBSITE_LINKS.home_page}>Home</a>
                      </li>
                      <li>
                        <a href={BOXIGO_WEBSITE_LINKS.about_us}>About Us</a>
                      </li>
                      <li>
                        <Link
                          // onClick={()=>{window.scrollTo(0, 0)}}
                          to={navigationsLinks.move_details_page}
                        >
                          Get a Quote
                        </Link>
                      </li>
                      <li>
                        <a href={BOXIGO_WEBSITE_LINKS.vendors}>Vendors</a>
                      </li>
                      <li>
                        <a href={BOXIGO_WEBSITE_LINKS.contact}>Contact</a>
                      </li>
                      <li>
                        <a
                          href={BOXIGO_WEBSITE_LINKS.vendor_login}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Vendor Login
                        </a>
                      </li>
                      <li>
                        <Link to="/login">Customer Login</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="contact-info">
                    <div className="address">
                      <h6 className="title"> Address </h6>
                      <p className="pr-4">
                      No. 26/10, 6th Cross, Ramanna Compound, Mangammanapalya, Bommanahalli, HSR Layout, Bengaluru, Karnataka - 560068
                      </p>
                    </div>
                    <div>
                      <h6 className="title"> Mail Us At </h6>
                      <p>
                        <a
                          href="mailto:support@boxigo.in"
                          className="text-lowercase"
                        >
                          support@boxigo.in
                        </a>
                      </p>
                      <h6 className="title"> Call Us At </h6>
                      <p>
                        <a href="tel:+918884448117">+91 88844 48117</a> <br />
                      </p>
                    </div>
                    <div>
                      <h6 className="title"> Quick Links </h6>
                      <ul className="p-0">
                        <li>
                          <a
                            href={BOXIGO_WEBSITE_LINKS.customer_faq}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Customer FAQ
                          </a>
                        </li>
                        <li>
                          <a
                            href={BOXIGO_WEBSITE_LINKS.vendor_faq}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Vendor FAQ
                          </a>
                        </li>
                        <li>
                          <a
                            href={BOXIGO_WEBSITE_LINKS.refund_policy}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Refund Policy{" "}
                          </a>
                        </li>
                        <li>
                          <a
                            href={
                              BOXIGO_WEBSITE_LINKS.vendor_terms_and_condition
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Vendor Terms and Conditions
                          </a>
                        </li>
                        <li>
                          <a
                            href={
                              BOXIGO_WEBSITE_LINKS.customer_terms_and_conditions_page
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Customer Terms and Conditions
                          </a>
                        </li>
                        <li>
                          <a href={BOXIGO_WEBSITE_LINKS.blog_page}>Blog</a>
                        </li>
                        <li>
                          <a href={BOXIGO_WEBSITE_LINKS.boxigo_site_map}>
                            Sitemap
                          </a>
                        </li>
                        <li className="mobile-link-toggle"><a href={BOXIGO_WEBSITE_LINKS.contact_us}> contact </a></li>
                           <li className="mobile-link-toggle"><a href={BOXIGO_WEBSITE_LINKS.about_us}> about us </a></li>
                           <li className="mobile-link-toggle"><a href={BOXIGO_WEBSITE_LINKS.vendors}> vendors </a></li>
                      </ul>
                    </div>
                    <div className="">
                      <h6 className="title"> Other Verticals </h6>
                      <ul className="p-0">
                        <li>
                          <a href={BOXIGO_WEBSITE_LINKS.home_page}>
                            Relocation
                          </a>
                        </li>
                        <li>
                          <a href={BOXIGO_WEBSITE_LINKS.storage_space}>
                            Storage Space
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>{" "}
                <div className="col-sm-12">
                  <FooterSEOLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row pb-3 copyright-and-terms">
          <div className="col-sm-12 col-md-6 text-left">
            © BOXIGO - ALL RIGHTS RESERVED 2020
          </div>
          <div className="col-sm-12 col-md-6 text-right">
            <a
              href={BOXIGO_WEBSITE_LINKS.customer_terms_and_conditions_page}
              target="_blank"
              rel="noopener noreferrer"
            >
              terms of usage
            </a>{" "}
            |{" "}
            <a
              href={BOXIGO_WEBSITE_LINKS.customer_privacy_policy_page}
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              privacy policy{" "}
            </a>
          </div>
        </div>
      </footer>
    </>
  );
  return JSX;
}

function FooterSEOLinks(props) {
  const [type, setType] = useState("movers");

  return (
    <>
      {" "}
      <ul className="nav nav-tabs seo-links mb-3" id="myTab" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-link ${type === "movers" ? "active" : ""}`}
            id="home-tab"
            onClick={() => setType("movers")}
            data-toggle="tab"
            href="#movers"
            role="tab"
            aria-controls="home"
            aria-selected="true"
          >
            Packers and Movers
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${type === "house" ? "active" : ""}`}
            id="profile-tab"
            data-toggle="tab"
            onClick={() => setType("house")}
            href="#house"
            role="tab"
            aria-controls="profile"
            aria-selected="false"
          >
            House shifting
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${type === "corporate" ? "active" : ""}`}
            id="contact-tab"
            data-toggle="tab"
            onClick={() => setType("corporate")}
            href="#corporate"
            role="tab"
            aria-controls="contact"
            aria-selected="false"
          >
            Corporate shifting
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${type === "vehicle" ? "active" : ""}`}
            id="contact-tab"
            data-toggle="tab"
            onClick={() => setType("vehicle")}
            href="#vehicle"
            role="tab"
            aria-controls="contact"
            aria-selected="false"
          >
            Vehicle Shifting{" "}
          </a>
        </li>
      </ul>
      <div className="tab-content" id="myTabContent">
        <div
          className={`tab-pane fade ${type === "movers" ? "show active" : ""}`}
          id="movers"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <p style={{ fontSize: "0.75rem" }}>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}packers-and-movers-bengaluru`}
            >
              {" "}
              Packers and Movers in bengaluru |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}packers-and-movers-hyderabad`}
            >
              {" "}
              Packers and Movers in Hyderabad |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}packers-and-movers-chennai`}
            >
              {" "}
              Packers and Movers in Chennai |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}packers-and-movers-mumbai`}
            >
              {" "}
              Packers and Movers in Mumbai{" "}
            </a>
          </p>
        </div>
        <div
          className={`tab-pane fade ${type === "house" ? "show active" : ""}`}
          id="house"
          role="tabpanel"
          aria-labelledby="profile-tab"
        >
          <p style={{ fontSize: "0.75rem" }}>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}house-shifting-bengaluru`}
            >
              {" "}
              House shifting in bengaluru |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}house-shifting-hyderabad`}
            >
              {" "}
              House shifting in Hyderabad |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}house-shifting-chennai`}
            >
              {" "}
              House shifting in Chennai |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}house-shifting-mumbai`}
            >
              {" "}
              House shifting in Mumbai{" "}
            </a>
          </p>
        </div>
        <div
          className={`tab-pane fade ${
            type === "corporate" ? "show active" : ""
          }`}
          id="corporate"
          role="tabpanel"
          aria-labelledby="contact-tab"
        >
          <p style={{ fontSize: "0.75rem" }}>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`corporate-shifting-bengaluru`}
            >
              {" "}
              Corporate Shifting in bengaluru |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}corporate-shifting-hyderabad`}
            >
              {" "}
              Corporate Shifting in Hyderabad |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}corporate-shifting-chennai`}
            >
              {" "}
              Corporate Shifting in Chennai |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}corporate-shifting-mumbai`}
            >
              {" "}
              Corporate Shifting in Mumbai{" "}
            </a>
          </p>
        </div>
        <div
          className={`tab-pane fade ${type === "vehicle" ? "show active" : ""}`}
          id="vehicle"
          role="tabpanel"
          aria-labelledby="contact-tab"
        >
          <p style={{ fontSize: "0.75rem" }}>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}vehicle-shifting-bengaluru`}
            >
              {" "}
              Vehicle shifting in bengaluru |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}vehicle-shifting-hyderabad`}
            >
              {" "}
              Vehicle shifting in Hyderabad |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}vehicle-shifting-chennai`}
            >
              {" "}
              Vehicle shifting in Chennai |{" "}
            </a>
            <a
              className="text-capitalize mr-2"
              rel="noopener noreferrer"
              href={`${config.customerPortal}vehicle-shifting-mumbai`}
            >
              {" "}
              Vehicle shifting in Mumbai{" "}
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
